import React from 'react';

const IntegrationsLaravo = () => {
  return (
    <>
      <section className="cb-integrations-details__section">
        <h3 className="cb-integrations-details__title">Overview</h3>

        <p>
          Connect Laravo with Clientbook to bring your brands&apos; product catalogs straight to your sales associates.
          This connection makes brand product information, including images and details, available inside
          Clientbook&apos;s desktop and mobile platforms, so your team can find the right product and share it with
          customers in the middle of a conversation. Click Install to get started!
        </p>

        <p>
          Brands keep their catalogs current in Laravo, and Clientbook pulls the latest data right away. Your associates
          always work from up-to-date product information without anyone tracking down images and specs by hand.
        </p>

        <p>
          To see a brand&apos;s catalog, you first need to be authorized by that brand. You can request access through
          Laravo, and once you&apos;re approved, the catalog shows up in Clientbook automatically.
        </p>
      </section>

      <section className="cb-integrations-details__section">
        <h3 className="cb-integrations-details__title">Getting Started</h3>

        <p>
          After you install Laravo and approve brand access, it can take up to 24 hours for brand catalogs to appear in
          Clientbook. This delay allows time for the Laravo API to sync your approved brands and their products. Once
          the sync completes, your associates will see the full catalog and can start sharing products with customers.
        </p>
      </section>

      <section className="cb-integrations-details__section">
        <h3 className="cb-integrations-details__title">Key Features</h3>

        <p>By adding Laravo to Clientbook, you can:</p>

        <ul className="cb-integrations-details__list">
          <li>Access product catalogs from your authorized brands.</li>

          <li>Get the latest data automatically as brands update their catalogs in Laravo, with no manual refresh.</li>

          <li>Give associates brand images and product details on both desktop and mobile, ready to send.</li>

          <li>
            Share products with customers directly from a Clientbook conversation to keep sales opportunities moving.
          </li>

          <li>
            Request access to new brands through Laravo and see their catalogs appear in Clientbook once approved.
          </li>
        </ul>
      </section>
    </>
  );
};

export default IntegrationsLaravo;
